/**
 * SystemTag automatically generated by SDKgen please do not edit this file manually
 * {@link https://sdkgen.app}
 */

import {TagAbstract, HttpRequest} from "sdkgen-client"
import {ClientException, UnknownStatusCodeException} from "sdkgen-client";

import {SystemConnectionTag} from "./SystemConnectionTag";
import {SystemMetaTag} from "./SystemMetaTag";
import {SystemPaymentTag} from "./SystemPaymentTag";

export class SystemTag extends TagAbstract {
    public connection(): SystemConnectionTag
    {
        return new SystemConnectionTag(
            this.httpClient,
            this.parser
        );
    }

    public meta(): SystemMetaTag
    {
        return new SystemMetaTag(
            this.httpClient,
            this.parser
        );
    }

    public payment(): SystemPaymentTag
    {
        return new SystemPaymentTag(
            this.httpClient,
            this.parser
        );
    }


}
